export default function remapRange(OldMin, OldMax, NewMin, NewMax, value) {
    return ((value - OldMin) * (NewMax - NewMin)) / (OldMax - OldMin) + NewMin
}
